import ButtonDelete from './src/main'

ButtonDelete.install = function (Vue) {
    Vue.components(ButtonDelete.name, ButtonDelete)
}

export default ButtonDelete